import { Component, inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

import { NAV_GROUPS, NavItem, View } from '~/models/document-finder.models';
import { DocumentFinderService } from '~/services/document-finder.service';

@Component({
    selector: 'df-sidebar',
    templateUrl: './df-sidebar.component.html',
    styleUrls: ['./df-sidebar.component.scss'],
    standalone: false
})
export class DfSidebarComponent {
    public readonly groups = NAV_GROUPS;
    private readonly auth = inject(MsalService, { optional: true });

    constructor(public df: DocumentFinderService) {}

    public get userName(): string {
        const account = this.auth?.instance.getActiveAccount() ?? this.auth?.instance.getAllAccounts()[0];
        return account?.name || account?.username || this.df.user;
    }

    public badge(item: NavItem): number | null {
        if (item.view === 'log') {
            const n = this.df.feedbackCount();
            return n || null;
        }
        if (item.view === 'packs' && this.df.packs.length) {
            return this.df.packs.length;
        }
        return null;
    }

    public select(view: View): void {
        this.df.navigate(view);
    }

    public toggle(): void {
        this.df.collapsed = !this.df.collapsed;
    }
}
